import ContractItemMobile from "./ContractItemMobile";

export default ContractItemMobile;
